'use es6';

import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import DraggableFieldBox from './DraggableFieldBox';
import { CreateNewFieldTypes, CreateNewFieldTypesPaginated } from 'ui-forms-components/constants/FieldTypeMapping';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { CLICKED_CREATE_FIELD_TILE } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
const TypesToRender = Object.keys(CreateNewFieldTypes);
const TypesToRenderPagination = Object.keys(CreateNewFieldTypesPaginated);
const getOptions = ungatedForPagination => {
  const normalTypes = ungatedForPagination ? TypesToRenderPagination : TypesToRender;
  let options = normalTypes;
  options = [...options];
  return options;
};
const FieldList = ({
  ungatedForPagination = false,
  handleClick = () => {}
}) => {
  const options = getOptions(ungatedForPagination);
  const handleHandleClick = key => {
    trackEditorInteraction(CLICKED_CREATE_FIELD_TILE, {
      fieldType: key
    });
    handleClick(null, {
      fieldType: key
    });
  };
  return /*#__PURE__*/_jsx(TFlex, {
    paddingInline: "300",
    wrap: "wrap",
    justify: "center",
    children: options.map(option => /*#__PURE__*/_jsx(Box, {
      margin: "200",
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "create-new-field-box",
        onClick: () => handleHandleClick(option),
        "data-field-type-option": option,
        children: /*#__PURE__*/_jsx(DraggableFieldBox, {
          fieldType: option,
          handleClick: handleClick
        })
      })
    }, option))
  });
};
export default FieldList;